// Email is only a navigation hint. Server RPCs grant every support permission.
export const SUPPORT_ACCOUNT_EMAIL = 'support@hubbing.ch'
export const staffSupportEnabled = (hostname, native = false) => !native && String(hostname || '').toLowerCase() === 'app.hubbing.ch'
export const isSupportAccount = user => String(user?.email || '').trim().toLowerCase() === SUPPORT_ACCOUNT_EMAIL
export const hasSupportDestination = search => {
  const params = new URLSearchParams(search)
  return ['support','support-app'].includes(params.get('screen')) || params.get('next') === 'support'
}
export const supportLoginPath = (pathname,screen='support') => `${pathname || '/'}?screen=${screen==='support-app'?'support-app':'support'}`
